import React, { Component } from 'react';
import API from '@/api/api';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, ConfigProvider, Input, message } from 'antd';

// /coupons/cardList

class CardList extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    columns: [
      {
        title: '模版ID',
        dataIndex: 'id',
      },
      {
        title: '卡名称',
        dataIndex: 'name',
      },
      {
        title: '剩余数量',
        dataIndex: 'leftNum',
      },
      {
        title: '操作',
        render: (_, record) => (
          <>
            <Button type="primary" onClick={this.ticketStatistics.bind(this, record.id)}>兑奖统计</Button>
            <Button style={{ marginLeft: '20px' }} type="primary" onClick={this.couponsCardAdd.bind(this, record.id)}>编辑</Button>
            <Button style={{ marginLeft: '20px' }} type="primary" onClick={this.cardTemplateDelete.bind(this, record.id)}>删除</Button>
          </>
        )
      }
    ],

    searchCondition: {
      name: undefined,
      pageSize: 5,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 5,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },

  }
  componentDidMount() {
    this.getListData()
  }

  onPaginationChange(page) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  searchForData() {
    let { searchCondition } = this.state;
    this.setState({ searchCondition }, () => {
      this.getListData();
    })
  }

  ticketStatistics(templateId) {
    this.props.history.push({ pathname: '/coupons/ticketStatistics', state: { templateId } })
  }

  couponsCardAdd(templateId) {
    this.props.history.push({ pathname: '/coupons/cardAdd', state: { templateId } })
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.cardTemplateList(searchCondition)
    if (result.status == 1) {
      let { datas, totalNum } = result.data;
      pagination.total = Number(totalNum);
      this.setState({ datas, pagination })
    }
  }

  InputItemChange(e) {
    let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
    let { searchCondition } = this.state;
    searchCondition.name = value
    this.setState({ searchCondition })
  }

  async cardTemplateDelete(templateId) {
    let result = await API.cardTemplateDelete({ templateId });
    if (result.status == 1) {
      this.getListData()
      message.error('已删除')
      return
    }
    message.error(result.msg)
  }

  render() {
    const {
      pagination,
      searchCondition,
      columns,
      datas,
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <div className="BrokerList">
          <Button style={{ margin: '20px 0 0 20px' }} type="primary" onClick={this.couponsCardAdd.bind(this, '')}>添加</Button>
          <div className="searchPane">
            <div className="leftCondition">
              <Input value={searchCondition.name} onChange={this.InputItemChange.bind(this)} placeholder="请输入卡名称"></Input>
            </div>
            <Button style={{ marginLeft: '20px' }} type="primary" onClick={this.searchForData.bind(this)}>查询</Button>
          </div>
          <Table
            columns={columns}
            dataSource={datas}
            pagination={pagination}
            rowKey='id'
          />
        </div>
      </ConfigProvider>
    )
  }
}

export default CardList